import * as React from 'react';

/**
 * Context instance (signleton)
 */
const Context = React.createContext<any>({
});

/**
 * Create a context instance that will 
 * be used by OneView context provider
 * 
 * @returns context instance
 */
export const context = () => (
    Context
);
